import React, {useEffect, useMemo, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import connect from "react-redux/es/components/connect";
import {Loading} from "../../../../../components/common";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import * as o2Api from "../../../../../api/api";
import numeral from "numeral";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../../../config/formatter";
import DefaultLayout from "../../../../../layout/DefaultLayout";
import StoreListWhere from "../../../where/StoreListWhere";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";
import StoreDetail from "../../../store/StoreDetail";
import {useSelector} from "react-redux";
import {gridColumnSum} from "../../../../../config/common";


const PopupCardApprDetail = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%" }), []);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]); //그리드


    const [columnDefs] = useState([

        {field: "statTime", headerName: "영업일자", width: 90},
        {field: "tradeDt", headerName: "거래일자", width: 90},
        {field: "tradeTm", headerName: "거래시간", width: 90},
        {field: "tradeTypeNm", headerName: "거래구분", width: 90},
        {field: "tradeType", headerName: "승인구분", width: 100, hide:true},
        {field: "bcmpName", headerName: "매입사", Width: 120},
        {field: "appNo", headerName: "승인번호", width: 100},
        {field: "cardNo", headerName: "카드번호", width: 150},
        {field: "payAmt", headerName: "승인금액", width: 90, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell" },
        {field: "vatAmt", headerName: "부가세", Width: 90, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "cardInstal", headerName: "할부구분", width: 80}
    ]);

    const [params] = useSearchParams();
    const queryList = [...params];


    useEffect(() => {

        const params = {
            cmpCd: queryList[0][1],
            brandCd: queryList[1][1],
            storeCd: queryList[2][1],
            fromSaleDt: queryList[3][1],
            toSaleDt: queryList[4][1]
        };

        getCardApprSaleDetail(params);
    }, []);


    const getCardApprSaleDetail = (params) => {
        setLoading(true);
        o2Api.getCardApprSaleDetail(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                setLoading(false);

                setGridData(responseBody);
                createStatTotalRowData(responseBody);
            } else {
                setLoading(false);
            }
        });
    }

    const createStatTotalRowData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            tradeTypeNm: "합계",
            payAmt: gridColumnSum(data, 'payAmt'),
            vatAmt: gridColumnSum(data, 'vatAmt')
        });
        api.setPinnedBottomRowData(result);
    };


    /*###################화면 Grid 영역###########################*/
    return (
        <>
            <div style={{height: 10}}/>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}


                <div style={{height: 10}}/>

                <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span
                        style={{
                            color: 'white',
                            fontWeight: 600
                        }}>매출일자 : </span>
                </div>


                <div style={{height: 10}}/>
                <div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                    <AgGridReact
                        ref={gridRef}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={gridData}
                        animateRows={true}
                        columnDefs={columnDefs}
                        rowSelection="multiple">
                    </AgGridReact>
                </div>
            </div>
        </>
    )
}



const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};
export default connect(mapStateToProps, null)(PopupCardApprDetail);

